export const getFormErrors = (error, fieldNames, fallbackMessage) => {
  const responseErrors = error.response?.data?.errors;

  if (!responseErrors || typeof responseErrors !== 'object') {
    return { submit: fallbackMessage };
  }

  const formErrors = {};
  let hasUnknownError = false;

  Object.entries(responseErrors).forEach(([name, message]) => {
    if (fieldNames.includes(name)) {
      formErrors[name] = message;
    } else {
      hasUnknownError = true;
    }
  });

  if (hasUnknownError || Object.keys(formErrors).length === 0) {
    formErrors.submit = fallbackMessage;
  }

  return formErrors;
};
